// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2m772","content":"styles_content__29wkz"};